import PhoneIcon from "@mui/icons-material/Phone";

export const menus = [
  {
    label: "+1 587-999-8722",
    value: "tel:+1 587-999-8722",
    icon: <PhoneIcon color="primary" sx={{ mr: 1 }} />,
  },
];
